import firebase from '../firebase.config'

firebase.analytics()

const analyticsEvents = (event, params) => {
  return firebase.analytics().logEvent(event, params)
}

export { analyticsEvents }
